if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();

        this.fieldsToRemove = [
          "__shopify_send_gift_card_to_recipient",
          "Recipient email",
          "Recipient name",
          "Message",
          "Send on"
        ];
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region`);

        this.checkboxInput = this.querySelector(`#Recipient-checkbox`);
        this.checkboxInput.disabled = false;

        this.hiddenControlField = this.querySelector(`#Recipient-control`);
        if (this.hiddenControlField) this.hiddenControlField.disabled = true;

        this.emailInput   = this.querySelector(`#Recipient-email`);
        this.nameInput    = this.querySelector(`#Recipient-name`);
        this.messageInput = this.querySelector(`#Recipient-message`);
        this.sendonInput  = this.querySelector(`#Recipient-send-on`);

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;

        const label = this.querySelector(`label[for="Recipient-checkbox"]`);
        this.checkmarkPolyline = label?.querySelector('polyline.checkmark');

        if (this.sendonInput) {
          const today = new Date();
          const year = today.getFullYear();
          const month = String(today.getMonth() + 1).padStart(2, '0');
          const day = String(today.getDate()).padStart(2, '0');
          this.sendonInput.value = `${year}-${month}-${day}`;
        }

        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();

        this.emailInput.addEventListener('change', this.onEmailInputChange.bind(this));
      }

      onChange() {

        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText =
            window.accessibilityStrings?.recipientFormExpanded || '';

          this.showCheckmark(true);
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText =
            window.accessibilityStrings?.recipientFormCollapsed || '';

          this.showCheckmark(false);
        }
      }

      onEmailInputChange(evt) {
        const emailValue = evt.target.value?.trim();
        if(!emailValue) return;
        if(emailValue){
          evt.target.classList.remove('error');
          const recipientForm = evt.target.closest('recipient-form');
          if(!recipientForm) return;
          if(recipientForm){
            recipientForm.clearErrorMessage();
          }
        }
      }

      showCheckmark(show) {
        if (!this.checkmarkPolyline) return;
        this.checkmarkPolyline.style.display = show ? 'inline' : 'none';
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return this.inputFields();
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
        if(typeof productPurchaseList != "undefined" && productPurchaseList) {
          productPurchaseList.buyItems.items.forEach(item => {
            if(item.properties) {
              this.fieldsToRemove.forEach(field => {
                delete item.properties[field];
              })
            }
            this.fieldsToRemove.forEach(field => {
              delete item[`properties[${field}]`];
            });
          });
        }
      }

      clearErrorMessage() {
        if (!this.errorMessageWrapper) return;

        this.errorMessageWrapper.hidden = true;
        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        this.inputFields().forEach((input) => {
          input.setAttribute('aria-invalid', false);
          input.removeAttribute('aria-describedby');
        });
      }
    }
  );
}
